import "core-js/modules/es6.function.name";
import n from "react";
import { ChevronRight as o, ChevronDown as t } from "@hagerty/icons";

var u = function u(_ref) {
  var r = _ref.item,
      e = _ref.onClick,
      a = _ref.isOpen;
  return n.createElement("button", {
    id: "primarynav__menubutton-link--".concat(r.name),
    className: "hg-primarynav__submenu-trigger-button",
    "aria-controls": "primarynav__submenu-link--".concat(r.name),
    "aria-expanded": a,
    "aria-label": "".concat(r.name.toLowerCase(), " menu"),
    type: "button",
    onClick: e
  }, n.createElement("span", {
    className: "hg-primarynav__image--regular hg-primarynav__submenu-button-icon"
  }, n.createElement(t, {
    width: 12,
    height: 12
  })), n.createElement("span", {
    className: "hg-primarynav__image--compact hg-primarynav__submenu-button-icon"
  }, n.createElement(o, null)));
};

export { u as SubmenuTriggerButton };